module.exports = __webpack_public_path__ + "static/brightteddyprint-551e42ad7941611257247bd0a82b020e.jpeg";